import { useNavigate } from "react-router-dom";
import { Play, Plus, Star, Check } from "lucide-react";
import { useState } from "react";

export default function MovieCard({ item, onAdd, inList, fluid }) {
  const navigate = useNavigate();
  const [added, setAdded] = useState(inList);

  return (
    <div
      data-testid={`movie-card-${item.id}`}
      onClick={() => navigate(`/title/${item.id}`)}
      className={`group relative shrink-0 snap-start cursor-pointer ${
        fluid ? "w-full" : "w-[150px] sm:w-[180px]"
      }`}
    >
      <div className="relative rounded-sm overflow-hidden bg-surface aspect-[2/3] border border-white/10 transition-all duration-500 group-hover:border-gold/60">
        <img
          src={item.poster_url}
          alt={item.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {typeof item.progress_pct === "number" && (
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20">
            <div className="h-full bg-gold" style={{ width: `${item.progress_pct}%` }} />
          </div>
        )}
        {(item.rent_price || item.buy_price) !== undefined && (
          <span className="absolute top-2 left-2 text-[10px] uppercase tracking-[0.15em] bg-black/60 backdrop-blur border border-gold/30 text-gold px-2 py-0.5 rounded-sm">
            {(Number(item.rent_price) <= 0 || Number(item.buy_price) <= 0) ? "Free" : `Rent $${item.rent_price ?? 3}`}
          </span>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex flex-col justify-end p-3">
          <p className="font-display font-semibold text-sm leading-tight line-clamp-2">{item.title}</p>
          <div className="flex items-center gap-2 mt-1 text-[11px] text-white/70">
            <span className="text-gold flex items-center gap-0.5"><Star className="w-3 h-3 fill-gold" strokeWidth={1.5} /> {item.rating}</span>
            <span>{item.release_year}</span>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <button
              data-testid={`card-play-${item.id}`}
              onClick={(e) => { e.stopPropagation(); navigate(`/watch/${item.id}`); }}
              className="w-8 h-8 rounded-full bg-gold text-black flex items-center justify-center hover:bg-gold-bright transition-colors"
            >
              <Play className="w-4 h-4 fill-black" strokeWidth={1.5} />
            </button>
            {onAdd && (
              <button
                data-testid={`card-add-${item.id}`}
                onClick={(e) => { e.stopPropagation(); setAdded(true); onAdd(item); }}
                className="w-8 h-8 rounded-full border border-white/40 bg-black/40 flex items-center justify-center hover:border-gold transition-colors"
              >
                {added ? <Check className="w-4 h-4 text-gold" strokeWidth={1.5} /> : <Plus className="w-4 h-4" strokeWidth={1.5} />}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
